import Button from '../../../common/components/button/button';
import FilterChips from '../../../common/components/filter-chips/filter-chips';
import Section from '../../../common/components/section/section';
import { dataSource } from '../../../global/config/data-source';
import { useAuth } from '../../../global/contexts/auth/auth';
import { useTheme } from '../../../global/contexts/theme/theme';

import '../styles/settings-panel.css';

const THEME_OPTIONS = [
    { value: 'system', label: 'Sistema' },
    { value: 'light', label: 'Claro' },
    { value: 'dark', label: 'Oscuro' },
];

export default function SettingsPanel() {
    const { theme, setTheme } = useTheme();
    const { user, logout } = useAuth();

    return (
        <Section title="Ajustes">
            <div className="settings-panel">
                <div className="settings-panel__row">
                    <p className="settings-panel__label">Apariencia</p>
                    <FilterChips label="Tema" options={THEME_OPTIONS} value={theme} onChange={setTheme} />
                </div>
                <div className="settings-panel__row">
                    <p className="settings-panel__label">Origen de datos</p>
                    <p className="settings-panel__value">
                        {dataSource.isDemo
                            ? 'Demostración en memoria. Ninguna llamada sale del dispositivo; recargar restablece los datos.'
                            : <>API de Core en <span className="mono">{dataSource.endpoint}</span></>}
                    </p>
                </div>
                <div className="settings-panel__row">
                    <p className="settings-panel__label">Sesión</p>
                    <p className="settings-panel__value">
                        {user?.name ?? '—'}
                        {dataSource.isDemo
                            ? ' (no hay sesión real; la biometría nunca crea una).'
                            : ' · cookie httpOnly gestionada por Core.'}
                    </p>
                    {!dataSource.isDemo && <Button size="small" variant="secondary" onClick={logout}>Cerrar sesión</Button>}
                </div>
            </div>
        </Section>
    );
}
